module.exports = __webpack_public_path__ + "img/icon_play_video.f4a5fe69.svg";